import { layout } from '../../App.routing'

export const stateElection2021Segment = layout.component({
    type: 'uniform',
    props: {
        section: 'news',
        verticalSpacing: 'xl',
        cardOrientation: { type: 'Landscape-Portrait' },

        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            {
                type: 'november',
                listLength: 5,
                hasTimestamp: true,
            },
        ],
        sectionHeader: {
            heading: 'State Election 2021',
            headingUrl: '/politics/state-election-2021',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'state-election-2021',
            offset: 0,
            pageSize: 8,
        },
    },
})
